import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setChangePassword = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CHANGE_PASSWORD_CASHIERS
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setChangePassword as SetChangePassword
}